import { Component, OnInit, ViewChild } from '@angular/core';
import { Popup } from 'ng2-opd-popup';
import { Location, LocationStrategy, PathLocationStrategy } from '@angular/common';
import { Router } from '@angular/router';
import { Http, RequestOptions, Headers } from '@angular/http';
import Swal from 'sweetalert2';
import { environment } from 'environments/environment';
import { CMSService } from '../../services/cms-service';
import { AdminService } from '../../services/admin';
import { Epidemimie } from 'model/modal-cms/epidemie';
import { Iec } from 'model/modal-cms/iec';
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgbdModalContent_Info } from '../../page/modal/ajout-docteur/info-visiteur/info-visiteur.component';

@Component({
  selector: 'app-index',
  templateUrl: './index.component.html',
  styleUrls: ['./index.component.scss']
})

export class IndexComponent implements OnInit {
  mode_daf: number = 1;
  Nombre_des_visiteurs : any;
  mode_daf2: number;
  nombre_visiteur: any;
  mode_btn: number = 1;
  test: Date = new Date();
  epidemimie: Epidemimie = new Epidemimie(null);
  iec: Iec = new Iec(null);
  @ViewChild('popupProcedure') popupProcedure: Popup;
  @ViewChild('popup5') popup5: Popup;
  @ViewChild('popupManuel') popupManuel: Popup;

  img : any = "img";
  urlfileIec: string = "assets/file/iec/torohevitra.pdf";
  urllogoIec_: string = "http://localhost/SiteCmsServeur/FileIEC/upload/img/upload_iec/image_commun.jpg";
  urllogoIec__ = environment.urllogoIec +"/cms/index.jpg";
  urllogoIec = environment.urllogoIec;

  //ROHICMSCOVID19

  private headers = new Headers({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'http://url-serv/' });
  nbr_covid19: any;
  date_covid19: Date;
  widthPopup: any = 65;
  headerPopup: any = "Actualités";
  infoIec: any;
  gesteBarriere: any;

  mot_defil: any;
  statistique_actu : any;

  constructor( private modalService: NgbModal, public location: Location, private router: Router, public cmsService: CMSService, public adminService: AdminService,) { }
  urlsli = "http://localhost/SiteCmsServeur/actu/"

  ngOnInit() {
    this.getmot_defil();
    //this.getGesteBarriere();
    this.getIecFile();
    this.getnombrevisiteur();
    let headers = new Headers();
    headers.append('Access-Control-Allow-Origin', 'http://localhost/SiteCmsServeur/actu/');
    let options = new RequestOptions({ headers: headers });
    return this.urlsli, options;

  }

  getmot_defil() {
    this.adminService.getmot_defil_by_etat("ACTU")
      .subscribe(data => {
        this.mot_defil = data.contenue_mot;
      }, err => {

      })
  }


  getGesteBarriere() {
    this.cmsService.getInfoGesteBarriere("CA")
      .subscribe(data => {
        this.gesteBarriere = data;  
        console.log(this.urllogoIec, this.gesteBarriere );
      },
        err => {
          console.log(err);
        })
  }

   getnombrevisiteur() {
    this.adminService.getnombrevisiteur()
      .subscribe(data => {
        this.nombre_visiteur = data;
        this.Nombre_des_visiteurs = "Nombre des visiteurs";
      }, err => {

      })
  }


  getIecFile() {
    this.cmsService.getIecAcc("C")
      .subscribe(data => {
        this.infoIec = data
      },
        err => {
          console.log(err);
        })
  }

  open_daf(id: any) {
    if (id == 1) {
      this.mode_daf2 = 1
      this.mode_btn = 2
    } else {
      this.mode_daf2 = 2
      this.mode_btn = 1
    }
  }



  se_connecter() {
    this.router.navigate(['login']);
  }

  medecins() {
    this.router.navigate(['medecins']);
  }


  index_() {
    this.router.navigate(['index']);

  }


  rmbrs() {
    Swal.fire({
      title: 'Authentification',
      icon: 'info',
      text: 'Pour plus de détails concernant votre remboursement, veuillez vous identifier.',
      showCancelButton: true,
      confirmButtonText: 'Oui, se connecter!',
      cancelButtonText: 'Non'
    }).then((result) => {
      if (result.value) {
        //ok btn         
        this.se_connecter();
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        //cancel btn
      }
    });
  }

  rdv() {
    Swal.fire({
      title: 'Authentification',
      icon: 'info',
      text: 'Pour toute demande de Rendez-vous, veuillez vous identifier.',
      showCancelButton: true,
      confirmButtonText: 'Oui, se connecter!',
      cancelButtonText: 'Non'
    }).then((result) => {
      if (result.value) {
        //ok btn         
        this.se_connecter();
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        //cancel btn
      }
    });
  }


  anl() {
    Swal.fire({
      title: 'Authentification',
      icon: 'info',
      text: 'Pour effectuer des analyses médicales, veuillez vous identifier.',
      showCancelButton: true,
      confirmButtonText: 'Oui, se connecter!',
      cancelButtonText: 'Non'
    }).then((result) => {
      if (result.value) {
        //ok btn         
        this.se_connecter();
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        //cancel btn
      }
    });
  }

  med() {
    Swal.fire({
      title: 'Authentification',
      icon: 'info',
      text: 'Pour consulter un médecin, veuillez vous identifier.',
      showCancelButton: true,
      confirmButtonText: 'Oui, se connecter!',
      cancelButtonText: 'Non'
    }).then((result) => {
      if (result.value) {
        //ok btn         
        this.se_connecter();
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        //cancel btn
      }
    });
  }

  act() {
    Swal.fire({
      title: 'Authentification',
      icon: 'info',
      text: 'Pour plus d\'actualités , veuillez vous identifier.',
      showCancelButton: true,
      confirmButtonText: 'Oui, se connecter!',
      cancelButtonText: 'Non'
    }).then((result) => {
      if (result.value) {
        //ok btn         
        this.se_connecter();
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        //cancel btn
      }
    });
  }


  nosservice() {
    Swal.fire({
      title: 'Authentification',
      icon: 'info',
      text: 'Pour plus de détails, veuillez vous identifier.',
      showCancelButton: true,
      confirmButtonText: 'Oui, se connecter!',
      cancelButtonText: 'Non'
    }).then((result) => {
      if (result.value) {
        //ok btn         
        this.se_connecter();
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        //cancel btn
      }
    });
  }


  Actualites_code_en_dure(id_actu: any) {
    this.popupProcedure.options = {
      cancleBtnClass: "btn btn-default",
      confirmBtnClass: "btn btn-success",
      color: "#0F7B79",
      showButtons: true,
      animationDuration: 2.5,
      header: this.headerPopup,
      widthProsentage: this.widthPopup,
      animation: "fadeInUp",
      confirmBtnContent: "Retour",
      cancleBtnContent: "Fermer",
    }
    if (id_actu == 1) {
      //corona
      this.getinfoipdemie();
    } else if (id_actu == 2) {
      // dengue
      this.urlfileIec = "assets/file/iec/DENGUE.pdf";
      this.popupProcedure.show(this.popupProcedure.options);
    } else if (id_actu == 3) {
      //bio
      this.urlfileIec = "assets/file/iec/Les bienfaits des aliments.pdf";
      this.popupProcedure.show(this.popupProcedure.options);
    } else if (id_actu == 4) {
      //torohevitra
      this.urlfileIec = "assets/file/iec/torohevitra.pdf";
      this.popupProcedure.show(this.popupProcedure.options);
    } else if (id_actu == 5) {
      // Manuele
      this.urlfileIec = "assets/file/iec/MANUEL_D_UTILISATION_CMS.pdf";
      this.widthPopup = 60;
      this.headerPopup = "Manuel Tomady";
      this.popupProcedure.show(this.popupProcedure.options);
    }
  }


  Actualites(id_actu: any) {
    this.popupProcedure.options = {
      cancleBtnClass: "btn btn-default",
      confirmBtnClass: "btn btn-success",
      color: "#0F7B79",
      showButtons: true,
      animationDuration: 2.5,
      header: this.headerPopup,
      widthProsentage: this.widthPopup,
      animation: "fadeInUp",
      confirmBtnContent: "Retour",
      cancleBtnContent: "Fermer",
    }
    if (id_actu == 1) {
      //corona
      this.getinfoipdemie();
    } else if (id_actu == 5) {
      // Manuele
      this.urlfileIec = "assets/file/iec/MANUEL_D_UTILISATION_CMS.pdf";
      this.widthPopup = 60;
      this.headerPopup = "Manuel Tomady";
      this.popupProcedure.show(this.popupProcedure.options);
    } else {
      this.cmsService.getInfoIEC(id_actu)
        .subscribe(data => {
          this.iec = data
          this.urlfileIec = "assets/file/iec/"+this.iec.fichier_iec;
          this.popupProcedure.show(this.popupProcedure.options);
        },
          err => {
            console.log(err);
          })

    }
  }



  // In my template, on button click, make api request
  Manuel_() {
    let symbol = "MANUEL_D_UTILISATION Site CMS.pdf"
    this.cmsService.getData(symbol)
      .subscribe(
        data => {
          console.log("pdf")
          console.log(data)
        },
        error => console.log("Error: " + error)
      )
  }




  Manuel() {
    this.popupManuel.options = {
      cancleBtnClass: "btn btn-default",
      confirmBtnClass: "btn btn-success",
      color: "#0F7B79",
      showButtons: true,
      animationDuration: 2.5,
      header: "Manuel d'utilisation Tomady",
      widthProsentage: 65,
      animation: "fadeInUp",
      confirmBtnContent: "Télécharger",
      cancleBtnContent: "Fermer",
    }
    //this.urlfileIec = "assets/file/iec/MANUEL_D_UTILISATION Site CMS.pdf";
  this.urlfileIec = "http://localhost/SiteCmsServeur/FileIEC/upload/file/iec/MANUEL_D_UTILISATION Site CMS.pdf";
    this.popupManuel.show(this.popupManuel.options);


  }

  telecharger() {
    //alefa le telechargement
    this.popupManuel.hide();
  }



  fermerProcedure() {
    this.popupProcedure.hide();
  }

  voir() {
    this.act();
  }


  getinfoipdemie() {
    let etat = "ACTU"
    this.cmsService.getInfoEvolutionEpidemiebyetet(etat)
      .subscribe(data => {
        this.epidemimie = data
        this.nbr_covid19 = this.epidemimie.text_epid
        this.date_covid19 = this.epidemimie.date_ajout
        if(this.epidemimie.image_actu === null){
          this.statistique_actu = "alerte_corona.PNG";
          this.popupnew();         
        }else{
          this.statistique_actu = this.epidemimie.image_actu;
          this.popupnew();
        }
       
      },
        err => {
          console.log(err);
        })
  }


  popupnew() {
    this.popup5.options = {
      cancleBtnClass: "btn btn-default",
      confirmBtnClass: "btn btn-danger",
      color: "#FF0000",
      showButtons: true,
      animationDuration: 2,
      header: "ALERT COVID-19",
      widthProsentage: 50,
      animation: "fadeInDown",
      confirmBtnContent: "En savoir plus",
      cancleBtnContent: "Fermer",
    }

    this.popup5.show(this.popup5.options);

  }


  open_info(){
    const modalRef = this.modalService.open(NgbdModalContent_Info);
    modalRef.componentInstance.name = 'modal-content';
   
  }


}
